module.exports = __webpack_public_path__ + "img/doc.8c44d278.svg";